import React, { useEffect, useMemo, useState } from "react";
import MidBox from "../../../components/Boxes/MidBox";
import useWatch from "../../hooks/useWatch";
import WatchLiveBattles from "./live-battles";
import HistoryBattles from "./history";
import "./style.css";
import { useSearchParams } from "react-router-dom";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
type Props = {};

export enum WatchTabs {
  LiveBattle = "live",
  BattleHistory = "history",
}
const WatchScreen = (props: Props) => {
  const { t } = useAppTranslation("battle");
  const [activeTab, setActiveTab] = useState<WatchTabs>(WatchTabs.LiveBattle);
  const { battleList, connector } = useWatch();
  const [searchParams,setSearchParams] = useSearchParams();
  const mode = searchParams.get("mode");
  const setMode = (mode: string) => {
    setSearchParams({mode});
  }
  useEffect(() => {
    if(mode){
      setActiveTab(mode as WatchTabs);
    }
  }, [mode]);


  const tabs = useMemo(
    () => ({
      [WatchTabs.LiveBattle]: {
        component: <WatchLiveBattles  />,
        disabled: false,
        title: t("watch.tabs.live"),
        badge: <div className="circle p-1 bg-danger"></div>,
      },
      [WatchTabs.BattleHistory]: {
        component: <HistoryBattles/>,
        disabled: false,
        title: t("watch.tabs.history"),
        badge:null
      },
    }),
    [t]
  );
  function handleChangeType(active: WatchTabs) {
    setMode(active);
  }
  return (
    <div className="mx-auto" style={{ maxWidth: 1200 }}>
      <MidBox modal title={t("watch.title")} containerClass="px-0 ">
        <div className="d-flex position-relative align-items-center justify-content-center gap-2">
          <img
            src="/assets/images/divider.svg"
            className="position-absolute mb-2 w-100"
            alt=""
          />
          {Object.entries(tabs).map(([key, tab]) => (
            <a
              style={{ maxWidth: 200 }}
              onClick={() => {
                handleChangeType(key as WatchTabs);
              }}
              className={
                " pb-4 pt-3  position-relative " +
                (key === activeTab && "active")
              }
            >
              <div className="b-text">
                <span className="text-light button m-0 p-0 pointer fs-med d-flex flex-column align-items-center  fs-lg fs-sm-small justify-content-center">
                  <img
                    className={"img-fluid"}
                    src={
                      activeTab === key
                        ? "/assets/images/buttons/active-tab-btn.png"
                        : "/assets/images/buttons/off-tab-btn.png"
                    }
                  />

                  <div className="position-absolute d-flex align-items-center justify-content-center gap-3 w-100">
                    <span>{tab.title}</span>
                    {tab.badge}
                  </div>
                </span>
              </div>
            </a>
          ))}
        </div>
        {tabs[activeTab].component}
      </MidBox>
    </div>
  );
};

export default WatchScreen;
